import { LineItem } from 'types/bonus-card-type';

const bonusUtil = {
  getAmountItem(item: LineItem | Omit<LineItem, 'beforeInsert'>): number {
    return item.bonus_amount ? item.bonus_amount : item.unit_price;
  },

  getOriginalCardValue(item: LineItem | Omit<LineItem, 'beforeInsert'>): number {
    if (item?.metadata?.card_value && typeof item.metadata.card_value === 'number') {
      return item.metadata.card_value as number;
    }
    return item.unit_price;
  },

  sort(items: LineItem[] | Omit<LineItem, 'beforeInsert'>[] | null | undefined): LineItem[] | Omit<LineItem, 'beforeInsert'>[] {
    return (items ?? []).sort((a, b) => {
      if (a.metadata?.business_external_id === b.metadata?.business_external_id) {
        return (a.bonus_amount ?? 0) - (b.bonus_amount ?? 0);
      }
      return String(a.metadata?.business_name ?? '').localeCompare(String(b.metadata?.business_name ?? ''));
    });
  },

  isBonusItem(item: LineItem | Omit<LineItem, 'beforeInsert'>): boolean {
    return !!item.bonus_amount;
  },

  isApplyBonusCard(cart: any) {
    return !!cart.bonus_code;
  },

  getPromoCode(cart: any) {
    return this.isApplyBonusCard(cart) ? cart.bonus_code : cart?.discounts[0]?.code;
  },

};

export default bonusUtil;
